import { render } from "./DangerForm.vue?vue&type=template&id=6c908e7d&scoped=true"
import script from "./DangerForm.vue?vue&type=script&lang=js"
export * from "./DangerForm.vue?vue&type=script&lang=js"

import "./DangerForm.vue?vue&type=style&index=0&id=6c908e7d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c908e7d"]])

export default __exports__